import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';

@Component({
  selector: 'app-re-provisional',
  templateUrl: './re-provisional.component.html',
  styleUrls: ['./re-provisional.component.scss']
})
export class ReProvisionalComponent implements OnInit {
  teacherREAssignForm: FormGroup;
  subjectList: any;
  filteredsubjectList: any;
  sessionList: any[];
  SessionFilterList: any[];
  CourseList: any;
  filteredListCourse: any;
  IsExter: number;
  IsInter: number;
  intExternalWaitingTeaArray: FormArray;
  teachersList: any;
  IsInterId: number;
  IsExterId: any;
  dialogRef: MatDialogRef<any>;
  constructor(public fb: FormBuilder,
      private modalPopupService: ModalpopService,
       private dialogRef2: MatDialogRef<ReProvisionalComponent>,
    public umsService: UmsService, @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,) { }

  ngOnInit(): void {
    console.log('thisssssssssssss', this.data.selected.value);

    this.teacherREAssignForm = this.fb.group({
      CoCode: new FormControl(''),
      SubCode: new FormControl(''),
      SessionId: new FormControl(''),
      intExternalWaitingTeaArray: this.fb.array([]),
    });
    this.fetchSession();
    this.getCourse();
  }




  fetchSession() {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        this.spinner.hide();
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  getsubjects(CoCode) {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = CoCode;
    this.umsService.getCoursewiseSub(payload).subscribe(res => {
      this.spinner.hide()
      this.subjectList = res.data;
      this.filteredsubjectList = this.subjectList.slice();
    });
  }


  getCourse() {
    this.spinner.show();
    const payload = {};
    // this.table = false;
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    })
  }

  getWaitingTeachersData() {
    if (this.data.selected.value.AssignFor === "Chairman/Convener" || this.data.selected.value.AssignFor == "Chairman/Convener") {
      this.IsExter = 0;
      this.IsInter = 1;
    } else if (this.data.selected.value.AssignFor === "External" || this.data.selected.value.AssignFor == "External") {
      this.IsExter = 1;
      this.IsInter = 0;
    }
    else {
      this.IsExter = 0;
      this.IsInter = 0;
    }
    this.spinner.show();
    const payload = {};
    payload['isExternal'] = this.IsExter;
    payload['isInternal'] = this.IsInter;
    payload['SubId'] = this.teacherREAssignForm.value.SubCode;
    payload['CoCode'] = this.teacherREAssignForm.value.CoCode;
    payload['SessionId'] = this.teacherREAssignForm.value.SessionId;
    payload['CgCode'] = this.data.selected.value.AssignClgCode;
    this.umsService.getWaitingTeachersData(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        console.log("resssssssssss", res.data);
        this.teachersList = res.data
        const intExternalWaitingTeaArray = this.teacherREAssignForm.get('intExternalWaitingTeaArray') as FormArray;
        intExternalWaitingTeaArray.clear();

        this.teachersList.forEach(teacher => {
          const teacherFormGroup = this.fb.group({
            TeacherId: new FormControl(teacher.TechId),
            TeacherName: new FormControl(teacher.TeacherName),
            CollegeName: new FormControl(teacher.CgName),
            EmId: new FormControl(teacher.EmId),
            // AssignClg: new FormControl(teacher.AssignedCgName),
            // AssignClgCode: new FormControl(teacher.AssignedCgCode),
            // Availability: new FormControl(teacher.Availability),
            // AcceptStatus: new FormControl(teacher.AcceptStatus),
            // AssignFor: new FormControl(teacher.AssignedFor),
          });
          intExternalWaitingTeaArray.push(teacherFormGroup);
        });
      }
      else {
        this.spinner.hide();

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();

    })
  }

  getControlsIntExternal() {
    return (this.teacherREAssignForm.get('intExternalWaitingTeaArray') as FormArray).controls;
  }

  ReProvision(data) {
    if (this.data.selected.value.AssignFor === "Chairman/Convener" || this.data.selected.value.AssignFor == "Chairman/Convener") {
      this.IsExterId = 0;
      this.IsInterId = this.data.selected.value.TeacherId;
    } else if (this.data.selected.value.AssignFor === "External" || this.data.selected.value.AssignFor == "External") {
      this.IsExterId = this.data.selected.value.TeacherId;
      this.IsInterId = 0;
    }
    else {
      this.IsExterId = 0;
      this.IsInterId = 0;
    }
    const payload = {};
    payload['InternalTechId'] = this.IsInterId;
    payload['ExternalTechId'] = this.IsExterId;
    payload['TechId'] = data.value.TeacherId;
    payload['EmId'] = data.value.EmId;
    payload['SubId'] = this.teacherREAssignForm.value.SubCode;
    payload['CoCode'] = this.teacherREAssignForm.value.CoCode;
    payload['SessionId'] = this.teacherREAssignForm.value.SessionId;
    payload['CgCode'] = this.data.selected.value.AssignClgCode;
    this.umsService.ReProvisionTeachersData(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        let data = {}
        data['message'] = "Re-Provisional Assingment Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close();
          this.ngOnInit();
        });
      }
      else {
        this.spinner.hide();

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();

    })
  }
}
